import React, { useEffect, useState } from 'react';

// ── Platform SVG Icons (inline, no import needed) ─────────────────────────────
const PLAT_ICONS = {
  Instagram:  <svg viewBox="0 0 24 24" width="16" height="16"><defs><radialGradient id="ig" cx="30%" cy="107%" r="150%"><stop offset="0%" stopColor="#fdf497"/><stop offset="45%" stopColor="#fd5949"/><stop offset="60%" stopColor="#d6249f"/><stop offset="90%" stopColor="#285AEB"/></radialGradient></defs><path fill="url(#ig)" d="M12 2.163c3.204 0 3.584.012 4.85.07 3.252.148 4.771 1.691 4.919 4.919.058 1.265.069 1.645.069 4.849 0 3.205-.012 3.584-.069 4.849-.149 3.225-1.664 4.771-4.919 4.919-1.266.058-1.644.07-4.85.07-3.204 0-3.584-.012-4.849-.07-3.26-.149-4.771-1.699-4.919-4.92-.058-1.265-.07-1.644-.07-4.849 0-3.204.013-3.583.07-4.849.149-3.227 1.664-4.771 4.919-4.919 1.266-.057 1.645-.069 4.849-.069zm0-2.163c-3.259 0-3.667.014-4.947.072-4.358.2-6.78 2.618-6.98 6.98-.059 1.281-.073 1.689-.073 4.948 0 3.259.014 3.668.072 4.948.2 4.358 2.618 6.78 6.98 6.98 1.281.058 1.689.072 4.948.072 3.259 0 3.668-.014 4.948-.072 4.354-.2 6.782-2.618 6.979-6.98.059-1.28.073-1.689.073-4.948 0-3.259-.014-3.667-.072-4.947-.196-4.354-2.617-6.78-6.979-6.98-1.281-.059-1.69-.073-4.949-.073zm0 5.838c-3.403 0-6.162 2.759-6.162 6.162s2.759 6.163 6.162 6.163 6.162-2.759 6.162-6.163c0-3.403-2.759-6.162-6.162-6.162zm0 10.162c-2.209 0-4-1.79-4-4 0-2.209 1.791-4 4-4s4 1.791 4 4c0 2.21-1.791 4-4 4zm6.406-11.845c-.796 0-1.441.645-1.441 1.44s.645 1.44 1.441 1.44c.795 0 1.439-.645 1.439-1.44s-.644-1.44-1.439-1.44z"/></svg>,
  Facebook:   <svg viewBox="0 0 24 24" width="16" height="16" fill="#1877f2"><path d="M24 12.073C24 5.405 18.627 0 12 0S0 5.405 0 12.073C0 18.1 4.388 23.094 10.125 24v-8.437H7.078v-3.49h3.047v-2.66c0-3.025 1.792-4.697 4.532-4.697 1.312 0 2.686.235 2.686.235v2.97h-1.513c-1.491 0-1.956.93-1.956 1.887v2.265h3.328l-.532 3.49h-2.796V24C19.612 23.094 24 18.1 24 12.073z"/></svg>,
  LinkedIn:   <svg viewBox="0 0 24 24" width="16" height="16" fill="#0a66c2"><path d="M20.447 20.452h-3.554v-5.569c0-1.328-.027-3.037-1.852-3.037-1.853 0-2.136 1.445-2.136 2.939v5.667H9.351V9h3.414v1.561h.046c.477-.9 1.637-1.85 3.37-1.85 3.601 0 4.267 2.37 4.267 5.455v6.286zM5.337 7.433c-1.144 0-2.063-.926-2.063-2.065 0-1.138.92-2.063 2.063-2.063 1.14 0 2.064.925 2.064 2.063 0 1.139-.925 2.065-2.064 2.065zm1.782 13.019H3.555V9h3.564v11.452zM22.225 0H1.771C.792 0 0 .774 0 1.729v20.542C0 23.227.792 24 1.771 24h20.451C23.2 24 24 23.227 24 22.271V1.729C24 .774 23.2 0 22.222 0h.003z"/></svg>,
  YouTube:    <svg viewBox="0 0 24 24" width="16" height="16" fill="#ff0000"><path d="M23.498 6.186a3.016 3.016 0 0 0-2.122-2.136C19.505 3.545 12 3.545 12 3.545s-7.505 0-9.377.505A3.017 3.017 0 0 0 .502 6.186C0 8.07 0 12 0 12s0 3.93.502 5.814a3.016 3.016 0 0 0 2.122 2.136c1.871.505 9.376.505 9.376.505s7.505 0 9.377-.505a3.015 3.015 0 0 0 2.122-2.136C24 15.93 24 12 24 12s0-3.93-.502-5.814zM9.545 15.568V8.432L15.818 12l-6.273 3.568z"/></svg>,
  WhatsApp:   <svg viewBox="0 0 24 24" width="16" height="16" fill="#25d366"><path d="M17.472 14.382c-.297-.149-1.758-.867-2.03-.967-.273-.099-.471-.148-.67.15-.197.297-.767.966-.94 1.164-.173.199-.347.223-.644.075-.297-.15-1.255-.463-2.39-1.475-.883-.788-1.48-1.761-1.653-2.059-.173-.297-.018-.458.13-.606.134-.133.298-.347.446-.52.149-.174.198-.298.298-.497.099-.198.05-.371-.025-.52-.075-.149-.669-1.612-.916-2.207-.242-.579-.487-.5-.669-.51-.173-.008-.371-.01-.57-.01-.198 0-.52.074-.792.372-.272.297-1.04 1.016-1.04 2.479 0 1.462 1.065 2.875 1.213 3.074.149.198 2.096 3.2 5.077 4.487.709.306 1.262.489 1.694.625.712.227 1.36.195 1.871.118.571-.085 1.758-.719 2.006-1.413.248-.694.248-1.289.173-1.413-.074-.124-.272-.198-.57-.347m-5.421 7.403h-.004a9.87 9.87 0 0 1-5.031-1.378l-.361-.214-3.741.982.998-3.648-.235-.374a9.86 9.86 0 0 1-1.51-5.26c.001-5.45 4.436-9.884 9.888-9.884 2.64 0 5.122 1.03 6.988 2.898a9.825 9.825 0 0 1 2.893 6.994c-.003 5.45-4.437 9.884-9.885 9.884m8.413-18.297A11.815 11.815 0 0 0 12.05 0C5.495 0 .16 5.335.157 11.892c0 2.096.547 4.142 1.588 5.945L.057 24l6.305-1.654a11.882 11.882 0 0 0 5.683 1.448h.005c6.554 0 11.89-5.335 11.893-11.893a11.821 11.821 0 0 0-3.48-8.413z"/></svg>,
  'X / Twitter': <svg viewBox="0 0 24 24" width="16" height="16" fill="#000"><path d="M18.244 2.25h3.308l-7.227 8.26 8.502 11.24H16.17l-4.714-6.231-5.401 6.231H2.747l7.73-8.835L1.254 2.25H8.08l4.259 5.63zm-1.161 17.52h1.833L7.084 4.126H5.117z"/></svg>,
  TikTok:     <svg viewBox="0 0 24 24" width="16" height="16" fill="#010101"><path d="M19.59 6.69a4.83 4.83 0 01-3.77-4.25V2h-3.45v13.67a2.89 2.89 0 01-2.88 2.5 2.89 2.89 0 01-2.89-2.89 2.89 2.89 0 012.89-2.89c.28 0 .54.04.79.1V9.01a6.33 6.33 0 00-.79-.05 6.34 6.34 0 00-6.34 6.34 6.34 6.34 0 006.34 6.34 6.34 6.34 0 006.33-6.34l-.01-8.83a8.2 8.2 0 004.82 1.55V4.58a4.85 4.85 0 01-1.04-.11z"/></svg>,
};

function PlatIcon({ name }) {
  return PLAT_ICONS[name] || <span style={{ fontSize:13, fontWeight:700, color:'var(--accent)' }}>{name?.[0]}</span>;
}

function fmtDt(iso) {
  if (!iso) return '—';
  const d = new Date(iso);
  return `${String(d.getDate()).padStart(2,'0')} ${d.toLocaleString('en-IN',{month:'short'})} ${d.getFullYear()}, ${String(d.getHours()).padStart(2,'0')}:${String(d.getMinutes()).padStart(2,'0')} ${d.getHours()>=12?'PM':'AM'}`;
}
function fmtDate(iso) {
  if (!iso) return '—';
  const d = new Date(iso);
  return `${String(d.getDate()).padStart(2,'0')} ${d.toLocaleString('en-IN',{month:'short'})} ${d.getFullYear()}`;
}

// ── Content Overview panel (shared across CC, Creatives, Post Copy) ────────────
export function ContentOverviewPanel({ wo, sc, type }) {
  const platforms  = Array.isArray(wo?.platforms)      ? wo.platforms      : [];
  const formats    = Array.isArray(wo?.output_formats)  ? wo.output_formats : [];
  const campaign   = wo?.campaign_type?.name || wo?.workflow_type || '—';
  const client     = typeof wo?.client === 'object' ? wo.client?.name : wo?.client || '—';

  const statusColor = (s) => {
    if (!s) return 'var(--text3)';
    if (/approved/i.test(s)) return 'var(--green)';
    if (/rejected/i.test(s)) return 'var(--red)';
    if (/pending/i.test(s))  return 'var(--yellow)';
    return 'var(--accent)';
  };

  const moduleStatus = type === 'content'   ? (sc?.approval_status || 'Draft')
                     : type === 'creatives' ? (sc?.status || 'Draft')
                     : type === 'postcopy'  ? (sc?.status || 'Draft')
                     : '—';

  return (
    <div className="detail-panel-card">
      <div className="detail-panel-header">Content Overview</div>
      <div className="detail-panel-body" style={{ padding:0 }}>

        {/* Platforms */}
        {platforms.length > 0 && (
          <div className="detail-panel-row" style={{ padding:'10px 16px', alignItems:'center' }}>
            <span className="detail-panel-label">Platforms</span>
            <div style={{ display:'flex', gap:6, flexWrap:'wrap' }}>
              {platforms.map(p => (
                <div key={p} title={p} style={{ display:'flex', alignItems:'center', justifyContent:'center', width:28, height:28, borderRadius:6, background:'var(--bg3)', border:'1px solid var(--border)' }}>
                  <PlatIcon name={p} />
                </div>
              ))}
            </div>
          </div>
        )}

        {/* Formats */}
        {formats.length > 0 && (
          <div className="detail-panel-row" style={{ padding:'10px 16px', flexDirection:'column', gap:6 }}>
            <span className="detail-panel-label">Content Formats</span>
            <div style={{ display:'flex', gap:4, flexWrap:'wrap' }}>
              {formats.map((f,i) => (
                <span key={i} style={{ padding:'2px 8px', background:'rgba(108,88,240,0.08)', border:'1px solid rgba(108,88,240,0.2)', borderRadius:12, fontSize:'0.68rem', fontWeight:600, color:'var(--accent2)', whiteSpace:'nowrap' }}>
                  {f.length > 28 ? f.slice(0,26)+'…' : f}
                </span>
              ))}
            </div>
          </div>
        )}

        {/* Campaign */}
        <div className="detail-panel-row" style={{ padding:'10px 16px' }}>
          <span className="detail-panel-label">Campaign</span>
          <span className="detail-panel-value">{campaign}</span>
        </div>

        {/* Status */}
        <div className="detail-panel-row" style={{ padding:'10px 16px' }}>
          <span className="detail-panel-label">Status</span>
          <span style={{ fontSize:'0.76rem', fontWeight:700, color: statusColor(moduleStatus) }}>
            {moduleStatus}
          </span>
        </div>

        {/* Event date */}
        {wo?.event_date && (
          <div className="detail-panel-row" style={{ padding:'10px 16px' }}>
            <span className="detail-panel-label">Event Date</span>
            <span className="detail-panel-value" style={{ fontFamily:'Space Mono,monospace', fontSize:'0.72rem' }}>
              {fmtDate(wo.event_date)}
            </span>
          </div>
        )}

        {/* WO */}
        <div className="detail-panel-row" style={{ padding:'10px 16px' }}>
          <span className="detail-panel-label">Work Order</span>
          <span style={{ fontFamily:'Space Mono,monospace', fontSize:'0.72rem', color:'var(--accent)', fontWeight:700 }}>
            {wo?.wo_number || `WO-${wo?.id}`}
          </span>
        </div>

        {/* Client */}
        <div className="detail-panel-row" style={{ padding:'10px 16px' }}>
          <span className="detail-panel-label">Client</span>
          <span className="detail-panel-value">{client}</span>
        </div>

        {/* Timestamps */}
        {sc?.created_at && (
          <div className="detail-panel-row" style={{ padding:'10px 16px' }}>
            <span className="detail-panel-label">Created On</span>
            <span className="detail-panel-value" style={{ fontSize:'0.72rem' }}>{fmtDt(sc.created_at)}</span>
          </div>
        )}
        {sc?.updated_at && (
          <div className="detail-panel-row" style={{ padding:'10px 16px', borderBottom:'none' }}>
            <span className="detail-panel-label">Last Updated</span>
            <span className="detail-panel-value" style={{ fontSize:'0.72rem' }}>{fmtDt(sc.updated_at)}</span>
          </div>
        )}
      </div>
    </div>
  );
}

// ── Approval Workflow panel ────────────────────────────────────────────────────
export function ApprovalWorkflowPanel({ type, sc }) {
  const steps = type === 'content' ? [
    { key:'internal', label:'Internal Approval',  sub:'Pending approval from internal team', doneAt: sc?.internal_approved_at, doneName: sc?.internal_approved_by, condition: ['Pending Client','Approved'].includes(sc?.approval_status) || !!sc?.internal_approved_at },
    { key:'client',   label:'Client Approval',    sub:'Pending client review',               doneAt: sc?.client_approved_at,   doneName: sc?.client_approved_by,   condition: sc?.approval_status === 'Approved' },
    { key:'approved', label:'Final Approved',      sub:'Ready for scheduling',                doneAt: null, doneName: null,       condition: sc?.approval_status === 'Approved' },
  ] : type === 'creatives' ? [
    { key:'internal', label:'Internal Review',     sub:'Design checked by internal team',    doneAt: sc?.internal_approved_at, doneName: sc?.internal_approved_by, condition: ['Pending Client','Approved'].includes(sc?.status) || !!sc?.internal_approved_at },
    { key:'client',   label:'Client Approval',     sub:'Client reviews the creative',         doneAt: sc?.client_approved_at,   doneName: sc?.client_approved_by,   condition: sc?.status === 'Approved' },
    { key:'approved', label:'Approved',            sub:'Ready for scheduling',                doneAt: null, doneName: null,       condition: sc?.status === 'Approved' },
  ] : [
    { key:'internal', label:'Internal Review',     sub:'Copy checked by internal team',      doneAt: sc?.internal_approved_at, doneName: sc?.internal_approved_by, condition: ['Pending Client','Approved','Approved Directly'].includes(sc?.status) || !!sc?.internal_approved_at },
    { key:'client',   label:'Client Approval',     sub:'Client reviews the copy',             doneAt: sc?.client_approved_at,   doneName: sc?.client_approved_by,   condition: ['Approved','Approved Directly'].includes(sc?.status) },
    { key:'approved', label:'Approved',            sub:'Ready for scheduling',                doneAt: null, doneName: null,       condition: ['Approved','Approved Directly'].includes(sc?.status) },
  ];

  const currentStatus = sc?.approval_status || sc?.status || 'Draft';
  const isRejected    = currentStatus === 'Rejected';

  return (
    <div className="detail-panel-card">
      <div className="detail-panel-header">Approval Workflow</div>
      <div className="detail-panel-body">
        {isRejected && (
          <div style={{ padding:'8px 10px', background:'rgba(239,68,68,0.08)', border:'1px solid rgba(239,68,68,0.2)', borderRadius:8, marginBottom:12, fontSize:'0.74rem', color:'var(--red)', fontWeight:600 }}>
            ↩ Revision requested — rework needed
          </div>
        )}
        {steps.map((step, i) => {
          const done   = step.condition && !isRejected;
          const active = !done && !isRejected && (
            (i === 0 && ['Draft','Pending Internal'].includes(currentStatus)) ||
            (i === 1 && currentStatus === 'Pending Client') ||
            (i === 2 && false)
          );
          return (
            <div key={step.key} className="approval-step">
              <div className={`approval-dot ${done ? 'done' : active ? 'active' : 'locked'}`}>
                {done ? '✓' : active ? '●' : i+1}
              </div>
              <div style={{ flex:1, paddingTop:1 }}>
                <div style={{ fontSize:'0.8rem', fontWeight:600, color: done ? 'var(--green)' : active ? 'var(--accent)' : 'var(--text2)' }}>
                  {step.label}
                </div>
                <div style={{ fontSize:'0.7rem', color:'var(--text3)', marginTop:2 }}>
                  {done && step.doneAt
                    ? `${step.doneName ? 'by ' + step.doneName + ' · ' : ''}${fmtDt(step.doneAt)}`
                    : step.sub}
                </div>
              </div>
            </div>
          );
        })}
      </div>
    </div>
  );
}

// ── Activity Feed panel ───────────────────────────────────────────────────────
export function ActivityPanel({ sc, type }) {
  const versions = sc?.versions || [];

  // Build activity from versions
  const events = [];

  if (sc?.created_at) {
    events.push({ label: 'Created', sub: '', at: sc.created_at, color:'var(--accent)', icon:'○' });
  }

  versions.slice().reverse().slice(0, 6).forEach(v => {
    const actionColors = {
      'Submitted':         'var(--accent)',
      'Internal Approved': 'var(--green)',
      'Client Approved':   'var(--green)',
      'Revision Requested':'var(--red)',
    };
    events.push({
      label: v.action || v.version,
      sub:   v.by || '',
      at:    v.at,
      color: actionColors[v.action] || 'var(--text3)',
      icon:  v.action === 'Submitted' ? '↑' : v.action?.includes('Approved') ? '✓' : v.action?.includes('Revision') ? '↩' : '·',
    });
  });

  events.sort((a,b) => new Date(b.at||0) - new Date(a.at||0));

  return (
    <div className="detail-panel-card">
      <div className="detail-panel-header" style={{ display:'flex', justifyContent:'space-between' }}>
        <span>Activity</span>
        {events.length > 4 && (
          <span style={{ fontSize:'0.68rem', color:'var(--accent)', fontWeight:500, cursor:'pointer' }}>View All</span>
        )}
      </div>
      <div className="detail-panel-body" style={{ padding:'8px 16px' }}>
        {events.length === 0 ? (
          <div style={{ color:'var(--text3)', fontSize:'0.78rem', padding:'8px 0' }}>No activity yet</div>
        ) : events.slice(0,5).map((ev, i) => (
          <div key={i} className="activity-item">
            <div style={{ width:20, height:20, borderRadius:'50%', background:`${ev.color}18`, border:`1.5px solid ${ev.color}`, display:'flex', alignItems:'center', justifyContent:'center', fontSize:'0.6rem', fontWeight:800, color:ev.color, flexShrink:0, marginTop:1 }}>
              {ev.icon}
            </div>
            <div style={{ flex:1, minWidth:0 }}>
              <div className="activity-text">{ev.label}{ev.sub ? ` — ${ev.sub}` : ''}</div>
              {ev.at && <div className="activity-time">{fmtDt(ev.at)}</div>}
            </div>
          </div>
        ))}
      </div>
    </div>
  );
}

// ── Main DetailPanel composite ────────────────────────────────────────────────
// type: 'content' | 'creatives' | 'postcopy'
// wo: work order object
// sc: the module record (script / creative / postCopy)
// onClose: callback to close panel
export default function DetailPanel({ wo, sc, type, onClose }) {
  // Keyboard close
  useEffect(() => {
    const h = (e) => { if (e.key === 'Escape') onClose?.(); };
    document.addEventListener('keydown', h);
    return () => document.removeEventListener('keydown', h);
  }, [onClose]);

  if (!wo) return null;

  return (
    <div className="detail-panel">
      <ContentOverviewPanel  wo={wo} sc={sc} type={type} />
      <ApprovalWorkflowPanel wo={wo} sc={sc} type={type} />
      <ActivityPanel         wo={wo} sc={sc} type={type} />
    </div>
  );
}
